import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthTenantService {


  private tenantSubject = new BehaviorSubject<TenantBranding | null>(null)
  tenant$ = this.tenantSubject.asObservable()

  getTenant(): TenantBranding | null {
    return this.tenantSubject.value;
  }

  setTenantFromApi(response: any) {
    const tenant = this.fromJson(response);

    this.tenantSubject.next(tenant);
  }

  // -------- JSON --------
  private fromJson(data: any): TenantBranding {
    return {
      name: data.name,
      logoUrl: data.logoUrl,
      primaryColor: data.primaryColor,
      secondaryColor: data.secondaryColor,
      loginText: data.loginText,
      tagline: data.tagLine,

      lmsLink: data.lmsLink,
      portalName: data.portalName,

      facebookLink: data.facebookLink,
      instagramLink: data.instagramLink,
      tikTokLink: data.tikTokLink,
      twitterLink: data.twitterLink,
      whatsappLink: data.whatsappLink
    };
  }


}
export interface TenantBranding {
  name: string;
  logoUrl: string;
  primaryColor: string;
  secondaryColor: string;
  loginText: string;

  tagline?: string;

  lmsLink?: string;
  portalName?: string;

  facebookLink?: string;
  instagramLink?: string;
  tikTokLink?: string;
  twitterLink?: string;
  whatsappLink?: string;
}


